// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__NDKKM"};